import React from "react";

import svg from "../../assets/images/icons/expand_all.svg";

export const ExpandAllIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Expand All"}
    />
);
